import { SELECIONAR_PASSAGEIRO } from '../types'

export default function selecionarPassageiro (passageiro) {
  return {
    type: SELECIONAR_PASSAGEIRO,
    payload: passageiro
  }
}
